export default __webpack_public_path__ + "static/media/whoarewe.aec6c4ed.webp";